import { render, staticRenderFns } from "./table-orders.component.vue?vue&type=template&id=9effd53e&scoped=true"
import script from "./table-orders.component.vue?vue&type=script&lang=js"
export * from "./table-orders.component.vue?vue&type=script&lang=js"
import style0 from "./table-orders.component.vue?vue&type=style&index=0&id=9effd53e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9effd53e",
  null
  
)

export default component.exports